<div class="status-message">
  <header class="header flex-1">
    <div>
      @switch (statusType) {
        @case (statusTypesEnum.SUCCESS) {
          <app-success-animation
            class="status-icon"
            width="50px"
            height="50px"
            [activateAnimation]="true"
          ></app-success-animation>
        }

        @case (statusTypesEnum.ERROR) {
          <svg-icon
            class="status-icon w-10 h-10"
            preserveAspectRatio="none"
            [src]="'status_not_started'"
            [stretch]="true"
          ></svg-icon>
        }
      }
    </div>

    <div class="title">
      <app-text [text]="buildTranslationKey('title') | translate"></app-text>
    </div>

    <ng-container *ngVar="buildTranslationKey('description') | translate: descriptionParams as translatedDescription">
      @if (translatedDescription !== buildTranslationKey('description')) {
        <div class="description">
          @if (withDescriptionText) {
            <app-text [text]="translatedDescription"></app-text>
          }
        </div>
      }
    </ng-container>
  </header>

  <footer>
    <ng-container *ngTemplateOutlet="customButtons ? customButtonsTemplate : defaultBtnTemplate"></ng-container>
  </footer>
</div>

<ng-template #customButtonsTemplate>
  @if (customButtons.mainButton; as btn) {
    <app-new-button
      class="modal-btn min-w-40"
      [attr.id]="btn.id"
      [size]="'responsive'"
      [type]="'primary'"
      [clickOnEnter]="true"
      (click)="customButtonHandlerExecute(btn)"
    >
      {{ buildTranslationKey(btn.translationKeyPart) | translate }}
    </app-new-button>
  }

  @if (customButtons.secondaryButton; as btn) {
    <app-new-button
      class="modal-btn min-w-40"
      [attr.id]="btn.id"
      [size]="'responsive'"
      [type]="'secondary'"
      (click)="customButtonHandlerExecute(btn)"
    >
      {{ buildTranslationKey(btn.translationKeyPart) | translate }}
    </app-new-button>
  }
</ng-template>

<ng-template #defaultBtnTemplate>
  <app-new-button
    data-test-id="got-it-btn"
    class="modal-btn {{ isMobile ? 'w-full sm:min-w-40 sm:w-auto' : 'min-w-40' }}"
    [size]="'responsive'"
    [type]="'primary'"
    [clickOnEnter]="true"
    (click)="close()"
  >
    {{ buildTranslationKey('btn') | translate }}
  </app-new-button>
</ng-template>
